import APIClient from '@/shared/http/clients/api'

const resourceName = 'grupo-economico'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)
const SearchPeopleIn = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/pessoasnogrupo/${document}?page=${index}&size=${limit}`, config)

/**
 * @name EconomicGroupRepository
 * @description Grupo económico
 * @type { Respository }
 */
const EconomicGroupRepository = {
  Search,
  SearchPeopleIn
}

export default EconomicGroupRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/economicgroup.js